const onContactPageMatch = async (pathname, regex) => {
  const getActiveContactEditId = () =>
    window.location.pathname.match(/^\/(?:persons\/)?view-person\/\d+\/edit-person\/(\d+)$/)?.[1] || null

  // Extract contact ID from URL
  const contactIdMatch = pathname.match(/\/edit-person\/(\d+)/)
  const contactId = contactIdMatch ? contactIdMatch[1] : null

  if (!contactId) {
    return
  }

  // Mark person view injects stale when the user saves or deletes a Kontaktmöglichkeit.
  // Closing edit navigates back to the same view-person URL without remounting;
  // onPersonViewPageMatch tears down and remounts Lux injects so they refetch
  // (no full page reload). Delete is also handled in multiContactUi after a
  // successful API delete (confirm + DELETE); that path cannot live only here
  // because this capture listener runs before the confirm dialog.
  const markPersonViewNeedsRefreshOnSpeichern = () => {
    if (window.__impowerxPersonViewStaleListenerInstalled) return
    window.__impowerxPersonViewStaleListenerInstalled = true
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target?.closest?.('button')
        if (!button) return
        const label = (button.textContent || '').replace(/\s+/g, ' ').trim()
        const isSave =
          label === 'Speichern' ||
          label === 'Speichern und Weiter' ||
          label === 'Save' ||
          label === 'Save and Continue'
        if (!isSave) return
        const editId = getActiveContactEditId()
        if (!editId) return
        window.__impowerxPersonViewNeedsRefresh = editId
      },
      true
    )
  }
  markPersonViewNeedsRefreshOnSpeichern()

  // Wait for the ContactEditing class and #person div to be available using MutationObserver
  const initializeTaxNumberField = () => {
    const contactEditing = document.querySelector('.ContactEditing')
    const personDiv = document.querySelector('#person')

    if (!contactEditing || !personDiv) {
      return false
    }

    // Get current contactId from URL
    const currentContactId = window.location.pathname.match(/\/edit-person\/(\d+)/)?.[1]
    if (!currentContactId) return false

    // Check if the field already exists - remove if contactId changed
    const existingTaxField = personDiv.querySelector('[data-field-name="taxNumber"]')
    const existingContactField = personDiv.querySelector('[data-field-name="contactComboBox"]')
    const existingActiveFromField = personDiv.querySelector('[data-field-name="substitutionActiveFrom"]')
    const existingActiveUntilField = personDiv.querySelector('[data-field-name="substitutionActiveUntil"]')
    const existingRows = [
      existingTaxField?.closest('.sub-section-content-row'),
      existingContactField?.closest('.sub-section-content-row'),
      existingActiveFromField?.closest('.sub-section-content-row'),
      existingActiveUntilField?.closest('.sub-section-content-row'),
    ].filter(Boolean)

    if (existingRows.length) {
      const hasAllFields = Boolean(
        existingTaxField &&
        existingContactField &&
        existingActiveFromField &&
        existingActiveUntilField
      )
      const hasTaxOnlyField = Boolean(
        existingTaxField &&
        !existingContactField &&
        !existingActiveFromField &&
        !existingActiveUntilField
      )
      const isSameContact = existingRows.every((row) => row?._contactId === currentContactId)

      //This check is made to handle SPA iisuues when handling anything from ppathname
      //SPA DOESN'T refresh pages , they simply chnage pathname via push or replace
      //this mean the coed here will not re-execute and we will have contact_id leak from previous visited page
      if ((hasAllFields || hasTaxOnlyField) && isSameContact) return true

      existingRows.forEach((row) => {
        row?._contactComboAbortController?.abort()
        // Ehepartner can live in the empty column of the Steuernummer row.
        // Removing that row without aborting leaves its document click listener
        // (and in-flight work) attached across SPA contact navigations.
        row
          ?.querySelectorAll?.('[data-ehepartner-ui="host"]')
          ?.forEach((host) => host._ehepartnerAbortController?.abort())
        row?.remove()
      })
    }

    // Find the sub-section-content div within #person
    const subSectionContent = personDiv.querySelector('.sub-section-content')
    if (!subSectionContent) {
      return false
    }

    // Find the last sub-section-content-row to insert after
    const rows = subSectionContent.querySelectorAll('.sub-section-content-row')
    const lastRow = rows[rows.length - 1]

    if (!lastRow) {
      return false
    }

    // Create first row for tax number field
    const taxRow = document.createElement('div')
    taxRow.className = 'sub-section-content-row'
    taxRow._contactId = currentContactId
    taxRow.innerHTML = `
      <div class="impowerx-tax-field-container"></div>
      <div class="sub-section-content-column"></div>
    `

    // Create second row for substitution contact field
    const substitutionRow = document.createElement('div')
    substitutionRow.className = 'sub-section-content-row'
    substitutionRow._contactId = currentContactId
    substitutionRow.innerHTML = `
      <style data-field-name="substitutionLabelStyle">
        .impowerx-no-after {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
        }
        .impowerx-no-after .impowerx-substitution-reset-button {
          font-size: 12px !important;
          height: 24px;
          padding: 0 8px;
          border-color: #ff4d4f;
          color: #ff4d4f;
          line-height: 1;
        }
        .impowerx-no-after::after {
          content: none !important;
        }
      </style>
      <div class="impowerx-contact-combobox-container"></div>
      <div class="sub-section-content-column"></div>
    `

    // Create third row for substitution date fields
    const substitutionDatesRow = document.createElement('div')
    substitutionDatesRow.className = 'sub-section-content-row'
    substitutionDatesRow._contactId = currentContactId
    substitutionDatesRow.innerHTML = `
      <div class="impowerx-active-from-container"></div>
      <div class="impowerx-active-until-container"></div>
    `

    const taxFieldContainer = taxRow.querySelector('.impowerx-tax-field-container')
    const taxField = generateInputField({
      id: 'taxNumber',
      fieldType: 'TextInput',
      name: 'taxNumber',
      label: 'Steuernummer / UStId-Nr',
      placeholder: 'Bitte ausfüllen...',
      value: '',
      isDisabled: false,
    })
    taxField.classList.remove('ehv-element')
    taxField.dataset.fieldName = 'taxNumber'
    taxField.querySelector('input')?.setAttribute('data-field-name', 'taxNumber')
    taxFieldContainer?.replaceWith(taxField)

    const contactComboContainer = substitutionRow.querySelector('.impowerx-contact-combobox-container')
    const contactComboField = generateInputField({
      id: 'contactComboBox',
      fieldType: 'ContactComboBox',
      name: 'contactComboBox',
      label: 'Vertretung',
      placeholder: 'Lade Kontakte...',
      options: [],
      isDisabled: true,
    })

    contactComboField.classList.remove('ehv-element')
    contactComboField.dataset.fieldName = 'contactComboBox'
    contactComboField.querySelector('.ant-select')?.setAttribute('data-field-name', 'contactComboBox')

    const contactComboLabelCol = contactComboField.querySelector('.ant-form-item-label')
    const contactComboLabel = contactComboLabelCol?.querySelector('label')
    if (contactComboLabelCol && contactComboLabel) {
      const labelWrapper = document.createElement('div')
      labelWrapper.className = 'impowerx-no-after'
      contactComboLabelCol.innerHTML = ''
      labelWrapper.append(contactComboLabel)

      const resetButton = document.createElement('button')
      resetButton.type = 'button'
      resetButton.className = 'ant-btn ant-btn-default Button impowerx-substitution-reset-button'
      resetButton.dataset.fieldName = 'substitutionReset'
      resetButton.innerHTML = '<span>Rücksetzen</span>'
      labelWrapper.append(resetButton)
      contactComboLabelCol.append(labelWrapper)
    }

    contactComboContainer?.replaceWith(contactComboField)

    const activeFromContainer = substitutionDatesRow.querySelector('.impowerx-active-from-container')
    const activeFromField = generateInputField({
      id: 'substitutionActiveFrom',
      fieldType: 'DateInput',
      name: 'substitutionActiveFrom',
      label: 'Aktiv ab (optional)',
      value: '',
      isDisabled: false,
    })
    activeFromField.classList.remove('ehv-element')
    activeFromField.dataset.fieldName = 'substitutionActiveFrom'
    activeFromField.querySelector('input')?.setAttribute('data-field-name', 'substitutionActiveFrom')
    activeFromContainer?.replaceWith(activeFromField)

    const activeUntilContainer = substitutionDatesRow.querySelector('.impowerx-active-until-container')
    const activeUntilField = generateInputField({
      id: 'substitutionActiveUntil',
      fieldType: 'DateInput',
      name: 'substitutionActiveUntil',
      label: 'Aktiv bis (optional)',
      value: '',
      isDisabled: false,
    })
    activeUntilField.classList.remove('ehv-element')
    activeUntilField.dataset.fieldName = 'substitutionActiveUntil'
    activeUntilField.querySelector('input')?.setAttribute('data-field-name', 'substitutionActiveUntil')

    activeUntilContainer?.replaceWith(activeUntilField)

    // Mark injected rows so they can be safely cleaned up on SPA navigation
    taxRow.dataset.impowerxContactExtra = 'true'
    substitutionRow.dataset.impowerxContactExtra = 'true'
    substitutionDatesRow.dataset.impowerxContactExtra = 'true'
    substitutionRow.style.display = 'none'
    substitutionDatesRow.style.display = 'none'

    // Insert the new rows after the last row
    lastRow.parentNode.insertBefore(taxRow, lastRow.nextSibling)
    taxRow.parentNode.insertBefore(substitutionRow, taxRow.nextSibling)
    substitutionRow.parentNode.insertBefore(substitutionDatesRow, substitutionRow.nextSibling)

    // Set up input change handler to sync with form state
    const taxInput = taxRow.querySelector('input[data-field-name="taxNumber"]')
    const contactSelect = substitutionRow.querySelector('.contact-combobox .ant-select')
    const contactSearchInput = substitutionRow.querySelector('.contact-combobox .ant-select-selection-search-input')
    const contactSelectionItem = substitutionRow.querySelector('.contact-combobox .ant-select-selection-item')
    const contactDropdown = substitutionRow.querySelector('.contact-combobox .impowerx-select-dropdown')
    const contactOptionsList = substitutionRow.querySelector('.contact-combobox .contact-combobox-list')
    const activeFromInput = substitutionDatesRow.querySelector('input[data-field-name="substitutionActiveFrom"]')
    const activeUntilInput = substitutionDatesRow.querySelector('input[data-field-name="substitutionActiveUntil"]')
    const substitutionResetButton = substitutionRow.querySelector('button[data-field-name="substitutionReset"]')
    let lastSelectedSubstituteId = ''

    // Disable input until data is loaded
    taxInput.disabled = true
    taxInput.classList.add('ant-input-disabled')
    taxInput.placeholder = 'Lade...'
    contactSearchInput.disabled = true
    contactSearchInput.placeholder = 'Lade Kontakte...'

    const setContactSelectDisabled = (isDisabled) => {
      contactSelect.setAttribute('disabled', String(isDisabled))
      contactSelect.classList.toggle('ant-select-disabled', isDisabled)
      contactSelect.classList.toggle('read-only', isDisabled)
      contactSearchInput.disabled = isDisabled
      if (isDisabled) {
        contactDropdown.classList.add('ant-select-dropdown-hidden')
      }
    }

    const escapeHtml = (value = '') =>
      String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')

    const renderContactOptions = (options = []) => {
      if (!contactOptionsList) {
        return
      }

      if (!options.length) {
        contactOptionsList.innerHTML = `
          <div class="ant-select-item ant-select-item-option ant-select-item-option-disabled" title="Keine Kontakte gefunden">
            <div class="ant-select-item-option-content">
              <div class="select-menu-item">Keine Kontakte gefunden</div>
            </div>
          </div>
        `
        return
      }

      contactOptionsList.innerHTML = options.map((option) => {
        const label = escapeHtml(option.label)
        const value = escapeHtml(option.value)
        return `
          <div class="ant-select-item ant-select-item-option contact-combobox-item" data-value="${value}" title="${label}">
            <div class="ant-select-item-option-content">
              <div class="select-menu-item">${label}</div>
            </div>
          </div>
        `
      }).join('')
    }

    const hideContactDropdown = () => {
      contactDropdown.classList.add('ant-select-dropdown-hidden')
    }

    const showContactDropdown = () => {
      if (
        contactSelect.classList.contains('ant-select-disabled') ||
        contactSelect.classList.contains('read-only')
      ) {
        return
      }

      contactDropdown.classList.remove('ant-select-dropdown-hidden')
      const previousValue = contactSelectionItem.textContent.trim()
      contactSelectionItem.textContent = ''
      contactSelectionItem.setAttribute('title', '')
      contactSearchInput.value = ''
      contactSearchInput.placeholder = previousValue || 'Kontakt auswählen...'
      contactSearchInput.focus()
      const allOptions = contactOptionsList.querySelectorAll('.contact-combobox-item')
      allOptions.forEach((option) => {
        option.style.display = ''
      })
    }

    contactSelect.addEventListener('click', (event) => {
      event.stopPropagation()
      if (contactDropdown.classList.contains('ant-select-dropdown-hidden')) {
        showContactDropdown()
        return
      }
      hideContactDropdown()
    })

    contactSearchInput.addEventListener('input', () => {
      const query = contactSearchInput.value.toLowerCase().trim()
      const options = contactOptionsList.querySelectorAll('.contact-combobox-item')

      options.forEach((option) => {
        const text = option.textContent.toLowerCase()
        option.style.display = text.includes(query) ? '' : 'none'
      })
    })

    contactOptionsList.addEventListener('click', (event) => {
      const selectedOption = event.target.closest('.contact-combobox-item')
      if (!selectedOption) {
        return
      }

      const selectedLabel = selectedOption.textContent.trim()
      const selectedValue = selectedOption.getAttribute('data-value')
      contactSelect.dataset.selectedValue = selectedValue || ''
      lastSelectedSubstituteId = selectedValue || ''
      contactSelectionItem.textContent = selectedLabel
      contactSelectionItem.setAttribute('title', selectedLabel)
      contactSearchInput.value = ''
      contactSearchInput.placeholder = ''
      hideContactDropdown()
      saveContactSubstitution()
    })

    const contactComboAbortController = new AbortController()
    substitutionRow._contactComboAbortController = contactComboAbortController

    document.addEventListener('click', (event) => {
      if (!substitutionRow.contains(event.target)) {
        hideContactDropdown()
      }
    }, { signal: contactComboAbortController.signal })

    const isContactSaveAction = (buttonElement) => {
      if (!buttonElement) {
        return false
      }

      // Exclude our inline reset button from save handling.
      if (buttonElement.closest('[data-field-name="substitutionReset"]')) {
        return false
      }

      if (buttonElement.getAttribute('type') === 'submit') {
        return true
      }

      const label = buttonElement.textContent?.toLowerCase().trim() || ''
      return label.includes('speichern')
    }

    document.addEventListener('click', (event) => {
      const clickedButton = event.target.closest('button')
      if (!clickedButton || !contactEditing.contains(clickedButton)) {
        return
      }

      if (isContactSaveAction(clickedButton)) {
        saveContactSubstitution()
      }
    }, { signal: contactComboAbortController.signal })

    const saveContactSubstitution = async ({ isDeleted = false, substituteIdOverride = null } = {}) => {
      try {
        const substituteId = substituteIdOverride || contactSelect.dataset.selectedValue || lastSelectedSubstituteId
        if (!substituteId) {
          return
        }

        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const token = authData.token

        if (!token) {
          return
        }

        const activeFrom = activeFromInput?.getValue?.() || null
        const activeUntil = activeUntilInput?.getValue?.() || null

        await fetch(`${baseApiUrl}/api/impowerX/contacts/substitution`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            contactId: currentContactId,
            substituteId,
            activeFrom,
            activeUntil,
            isDeleted,
          }),
        })
      } catch (error) {
        console.error('Error saving contact substitution:', error)
      }
    }

    const parseDateToInputValue = (value) => {
      if (!value) {
        return ''
      }

      const parsedDate = new Date(value)
      if (Number.isNaN(parsedDate.getTime())) {
        return ''
      }

      const year = parsedDate.getFullYear()
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0')
      const day = String(parsedDate.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }

    const prefillCurrentSubstitution = async (contactOptions = []) => {
      try {
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const token = authData.token

        if (!token) {
          return
        }

        const response = await fetch(
          `${baseApiUrl}/api/impowerX/contacts/substitution?contactId=${currentContactId}`,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        )

        if (!response.ok) {
          return
        }

        const data = await response.json()
        const substitution = data?.substitution

        if (!substitution) {
          return
        }

        const substituteId = String(substitution.substituteId || '')
        if (!substituteId) {
          return
        }

        const selectedContact = contactOptions.find(
          (option) => String(option.value) === substituteId
        )

        contactSelect.dataset.selectedValue = substituteId
        lastSelectedSubstituteId = substituteId
        contactSelectionItem.textContent = selectedContact?.label || substituteId
        contactSelectionItem.setAttribute('title', selectedContact?.label || substituteId)
        contactSearchInput.value = ''
        contactSearchInput.placeholder = ''
        activeFromInput?.setValue?.(parseDateToInputValue(substitution.activeFrom))
        activeUntilInput?.setValue?.(parseDateToInputValue(substitution.activeUntil))
      } catch (error) {
        console.error('Error loading current contact substitution:', error)
      }
    }

    substitutionResetButton?.addEventListener('click', async (event) => {
      event.preventDefault()
      event.stopPropagation()

      const substituteIdToDelete = contactSelect.dataset.selectedValue || lastSelectedSubstituteId

      contactSelect.dataset.selectedValue = ''
      contactSelectionItem.textContent = ''
      contactSelectionItem.setAttribute('title', '')
      contactSearchInput.value = ''
      contactSearchInput.placeholder = 'Kontakt auswählen...'
      activeFromInput?.setValue?.('')
      activeUntilInput?.setValue?.('')
      hideContactDropdown()

      if (substituteIdToDelete) {
        await saveContactSubstitution({
          isDeleted: true,
          substituteIdOverride: substituteIdToDelete,
        })
      }

      lastSelectedSubstituteId = ''
    })

    const loadContacts = async () => {
      try {
        const contactsData = await getImpowerXData(`${baseApiUrl}/api/impowerX/contacts?onlyEmployees=true`).catch((error) => {
          console.error('Error fetching contacts:', error)
          return {}
        })

        if (!document.body.contains(substitutionRow)) {
          return
        }

        const contacts = Array.isArray(contactsData?.contacts) ? contactsData.contacts : []
        const isCurrentContactEmployee = contacts.some(
          (contact) => String(contact?.id || '') === String(currentContactId)
        )

        if (!isCurrentContactEmployee) {
          contactComboAbortController.abort()
          substitutionRow.remove()
          substitutionDatesRow.remove()
          return
        }

        substitutionRow.style.display = ''
        substitutionDatesRow.style.display = ''

        const contactOptions = contacts.map((contact) => {
          const fullName = `${contact?.firstName || ''} ${contact?.lastName || ''}`.trim()
          return {
            label: contact?.companyName || fullName || contact?.name || `Kontakt ${contact?.id || ''}`.trim(),
            value: contact?.id || '',
          }
        }).filter((contact) => contact.value)

        renderContactOptions(contactOptions)
        await prefillCurrentSubstitution(contactOptions)
      } catch (error) {
        console.error('Error loading contacts for combobox:', error)
        renderContactOptions([])
      } finally {
        if (!document.body.contains(substitutionRow)) {
          return
        }
        setContactSelectDisabled(false)
        contactSearchInput.placeholder = contactSelect.dataset.selectedValue ? '' : 'Kontakt auswählen...'
      }
    }

    loadContacts()

    // Load existing tax number from API
    const loadTaxNumber = async () => {
      try {
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const token = authData.token

        if (!token) {
          // Enable input even if token is missing
          taxInput.disabled = false
          taxInput.classList.remove('ant-input-disabled')
          taxInput.placeholder = 'Bitte ausfüllen...'
          return
        }

        const response = await fetch(
          `${baseApiUrl}/api/impowerX/contacts/tax-number?contactId=${currentContactId}`,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        )

        if (response.ok) {
          const data = await response.json()
          if (data.taxNumber) {
            taxInput.value = data.taxNumber
          }
        }
      } catch (error) {
        console.error('Error loading tax number:', error)
      } finally {
        // Always enable input after load attempt (success or failure)
        taxInput.disabled = false
        taxInput.classList.remove('ant-input-disabled')
        taxInput.placeholder = 'Bitte ausfüllen...'
      }
    }

    // Load tax number after a short delay
    setTimeout(loadTaxNumber, 500)

    // Debounced save function
    let saveTimeout = null
    const saveTaxNumber = async (value) => {
      try {
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const token = authData.token

        if (!token) {
          return
        }

        const taxNumberValue = (value || taxInput.value || '').trim()

        const response = await fetch(
          `${baseApiUrl}/api/impowerX/contacts/tax-number`,
          {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              contactId: currentContactId,
              taxNumber: taxNumberValue || null,
            }),
          }
        )

        if (response.ok) {
          await response.json()
        }
      } catch (error) {
        // Error saving tax number
      }
    }

    // Set up debounced input change handler
    taxInput.addEventListener('input', (e) => {
      const value = e.target.value

      // Clear existing timeout
      if (saveTimeout) {
        clearTimeout(saveTimeout)
      }

      // Set new timeout to save after 1 second of no typing
      saveTimeout = setTimeout(() => {
        saveTaxNumber(value)
      }, 1000)
    })

    return true
  }

  const initializeTaxAssumption = () => {
    const personDiv = document.querySelector('#person')
    if (personDiv) {
      taxAssumptionEditor(baseApiUrl)
    }
  }

  // The "Speichern" button lives outside `.ContactEditing` (page header / overlay
  // footer), so a delegated click listener scoped to the form never fires for it.
  // We install a capture-phase listener (matches by button text) so notification
  // settings are persisted before the host save handler can navigate away.
  const NOTIFICATIONS_SETTINGS_SECTION_ID = 'ImpowerxContactNotificationsSettings'
  const contactNotificationsSaveState =
    window.__impowerxContactNotificationsSaveState ||
    (window.__impowerxContactNotificationsSaveState = {
      contactId: null,
      saver: null,
      needsSave: null,
      hostSpeichernReplay: null,
      bypassGate: false,
      speichernListenerInstalled: false,
    })

  const clearNotificationsSaver = (contactIdToClear = null) => {
    if (contactIdToClear && contactNotificationsSaveState.contactId !== contactIdToClear) {
      return
    }

    contactNotificationsSaveState.contactId = null
    contactNotificationsSaveState.saver = null
    contactNotificationsSaveState.needsSave = null
    contactNotificationsSaveState.getSaveInFlight = null
    contactNotificationsSaveState.releaseHostSpeichernReplayGate?.()
    contactNotificationsSaveState.releaseHostSpeichernReplayGate = null
  }

  const triggerNotificationsSaver = async (event) => {
    if (contactNotificationsSaveState.bypassGate) return

    const activeContactId = getActiveContactEditId()
    if (!activeContactId || activeContactId !== contactNotificationsSaveState.contactId) {
      clearNotificationsSaver()
      return
    }

    const section = document.getElementById(NOTIFICATIONS_SETTINGS_SECTION_ID)
    if (
      !section ||
      section._contactId !== activeContactId ||
      !document.body.contains(section)
    ) {
      clearNotificationsSaver(activeContactId)
      return
    }

    const hadDirtyNotifications =
      typeof contactNotificationsSaveState.needsSave === 'function' &&
      contactNotificationsSaveState.needsSave()
    const saveInFlightPromise =
      typeof contactNotificationsSaveState.getSaveInFlight === 'function'
        ? contactNotificationsSaveState.getSaveInFlight()
        : null
    const pendingHostReplay = contactNotificationsSaveState.hostSpeichernReplay

    if (
      !hadDirtyNotifications &&
      !saveInFlightPromise &&
      !pendingHostReplay
    ) {
      return
    }

    if (typeof contactNotificationsSaveState.saver !== 'function') {
      return
    }

    // Capture phase: finish the notification POST before the host save handler
    // runs and potentially navigates away or tears down the edit form DOM.
    event.preventDefault()
    event.stopImmediatePropagation()

    // Capture the button synchronously: the browser nulls out event.currentTarget
    // once dispatch completes, which happens as soon as the first await below yields.
    const button = event.currentTarget
    if (!(button instanceof HTMLButtonElement)) return

    // Reserve a pending gate before any await so follow-up Speichern clicks
    // during the notification POST block until host replay is chained (unlike
    // Promise.resolve(), which would let them pass await immediately).
    if (hadDirtyNotifications && !contactNotificationsSaveState.hostSpeichernReplay) {
      let releaseHostSpeichernReplayGate
      contactNotificationsSaveState.hostSpeichernReplay = new Promise((resolve) => {
        releaseHostSpeichernReplayGate = resolve
      })
      contactNotificationsSaveState.releaseHostSpeichernReplayGate =
        releaseHostSpeichernReplayGate
    }

    if (hadDirtyNotifications) {
      try {
        await contactNotificationsSaveState.saver()
      } catch (error) {
        console.error('Error saving notification settings on Speichern:', error)
      }
    } else if (saveInFlightPromise) {
      await saveInFlightPromise
    }

    if (!hadDirtyNotifications) {
      if (pendingHostReplay) {
        await pendingHostReplay
      }
      const hostReplay = contactNotificationsSaveState.hostSpeichernReplay
      if (hostReplay) {
        await hostReplay
        return
      }
      if (!saveInFlightPromise) {
        return
      }
      // Notification POST was in flight when this click was blocked, but no
      // replay was reserved yet (or the dirty click's replay already finished).
    }

    // Serialize host replays so concurrent/back-to-back clicks each replay
    // their own button (e.g. Speichern vs Speichern und Weiter).
    const replayPromise = (
      contactNotificationsSaveState.hostSpeichernReplay || Promise.resolve()
    ).then(() => {
      contactNotificationsSaveState.bypassGate = true
      try {
        button.click()
      } finally {
        contactNotificationsSaveState.bypassGate = false
      }
    })

    // `.finally()` returns a new promise, so compare against the wrapper we
    // actually store (not `replayPromise`) or the identity check never matches
    // and `hostSpeichernReplay` would stay non-null forever, blocking all
    // subsequent non-dirty Speichern clicks.
    const trackedReplay = replayPromise.finally(() => {
      if (contactNotificationsSaveState.hostSpeichernReplay === trackedReplay) {
        contactNotificationsSaveState.hostSpeichernReplay = null
      }
    })
    contactNotificationsSaveState.hostSpeichernReplay = trackedReplay

    contactNotificationsSaveState.releaseHostSpeichernReplayGate?.()
    contactNotificationsSaveState.releaseHostSpeichernReplayGate = null

    await replayPromise
  }

  const listenToSpeichernButtonCapture = (buttonText, onClicked) => {
    const registered = new WeakMap()

    const observer = new MutationObserver(() => {
      const button = Array.from(document.querySelectorAll('button')).find(
        (btn) => btn.textContent === buttonText
      )

      if (!button) return

      let handlers = registered.get(button)
      if (!handlers) {
        handlers = new Set()
        registered.set(button, handlers)
      }

      if (!handlers.has(onClicked)) {
        handlers.add(onClicked)
        button.addEventListener('click', onClicked, true)
      }
    })

    observer.observe(document.querySelector('body'), {
      childList: true,
      subtree: true,
    })
  }

  const ensureNotificationsSpeichernListener = () => {
    if (contactNotificationsSaveState.speichernListenerInstalled) return
    contactNotificationsSaveState.speichernListenerInstalled = true
    listenToSpeichernButtonCapture('Speichern', triggerNotificationsSaver)
    listenToSpeichernButtonCapture('Speichern und Weiter', triggerNotificationsSaver)
    listenToSpeichernButtonCapture('Save', triggerNotificationsSaver)
    listenToSpeichernButtonCapture('Save and Continue', triggerNotificationsSaver)
  }

  const NOTIFICATION_SETTING_DEFINITIONS = [
    { key: 'all', label: 'E-Mail-Benachrichtigungen aktivieren', isChild: false },
    { key: 'statusChanges', label: 'E-Mail Benachrichtigung für Statusänderungen', isChild: true },
    { key: 'newUploadedDocuments', label: 'E-Mail-Benachrichtigungen für neue hochgeladene Dokumente', isChild: true },
    { key: 'phaseChanges', label: 'E-Mail Benachrichtigung für Phasenänderungen', isChild: true },
  ]

  const NOTIFICATIONS_DEFAULT_SETTINGS = {
    all: true,
    statusChanges: true,
    newUploadedDocuments: true,
    phaseChanges: false,
  }

  const injectNotificationsSectionStyles = () => {
    if (document.getElementById('impowerx-contact-notifications-style')) return
    const style = document.createElement('style')
    style.id = 'impowerx-contact-notifications-style'
    style.textContent = `
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-subtitle {
        margin: 0 0 16px;
        font-size: 13px;
        line-height: 1.5;
        color: rgba(0, 0, 0, 0.55);
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-status {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.55);
        margin-bottom: 12px;
        min-height: 0;
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-status:empty {
        display: none;
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-status.is-error {
        color: #ff4d4f;
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 10px 0;
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-row.is-child {
        padding-left: 24px;
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-label {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-switch {
        position: relative;
        display: inline-block;
        flex: 0 0 auto;
        width: 44px;
        height: 24px;
        cursor: pointer;
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #d9d9d9;
        transition: background-color 0.2s;
        border-radius: 24px;
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-slider::before {
        position: absolute;
        content: "";
        height: 20px;
        width: 20px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        transition: transform 0.2s;
        border-radius: 50%;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-switch input:checked + .impowerx-notifications-slider {
        background-color: #1a1a1a;
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-switch input:checked + .impowerx-notifications-slider::before {
        transform: translateX(20px);
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-switch.is-disabled {
        cursor: not-allowed;
      }
      #${NOTIFICATIONS_SETTINGS_SECTION_ID} .impowerx-notifications-switch.is-disabled .impowerx-notifications-slider {
        opacity: 0.5;
        cursor: not-allowed;
      }
    `
    document.head.appendChild(style)
  }

  // Editable notifications section. Changes are buffered locally and only persisted
  // to the API when the user clicks the "Speichern" button on the contact edit form.
  const initializeNotificationsSettingsSection = () => {
    const contactEditing = document.querySelector('.ContactEditing')
    const personDiv = document.querySelector('#person')
    if (!contactEditing || !personDiv) {
      clearNotificationsSaver()
      return false
    }

    const currentContactId = getActiveContactEditId()
    if (!currentContactId) {
      clearNotificationsSaver()
      return false
    }

    const existing = document.getElementById(NOTIFICATIONS_SETTINGS_SECTION_ID)
    if (existing) {
      if (
        existing._contactId === currentContactId &&
        document.body.contains(existing) &&
        contactNotificationsSaveState.contactId === currentContactId &&
        typeof contactNotificationsSaveState.saver === 'function'
      ) {
        return true
      }
      clearNotificationsSaver(existing._contactId)
      existing._abortController?.abort()
      existing.remove()
    }

    injectNotificationsSectionStyles()

    const section = document.createElement('div')
    section.className = 'sub-section'
    section.id = NOTIFICATIONS_SETTINGS_SECTION_ID
    section._contactId = currentContactId
    section.dataset.impowerxContactExtra = 'true'

    section.innerHTML = `
      <div class="sub-section-header">
        <div class="sub-section-title">
          <span>Benachrichtigungseinstellungen</span>
        </div>
      </div>
      <div class="sub-section-content">
        <div class="impowerx-notifications-subtitle">Durch das Klicken von "Speichern" werden diese Benachrichtigungseinstellungen für diesen Kontakt gesetzt. Sie gelten auch dann, wenn der Kontakt erst später dem Portal beitritt.</div>
        <div class="impowerx-notifications-status">Lade Benachrichtigungseinstellungen...</div>
        <div class="impowerx-notifications-body"></div>
      </div>
    `

    const statusEl = section.querySelector('.impowerx-notifications-status')
    const body = section.querySelector('.impowerx-notifications-body')
    const inputsByKey = {}
    let currentSettings = { ...NOTIFICATIONS_DEFAULT_SETTINGS }
    let isRegistered = false
    let isLoaded = false
    let isDirty = false
    let saveInFlight = null

    const abortController = new AbortController()
    section._abortController = abortController

    const setStatusMessage = (message, { isError = false } = {}) => {
      statusEl.textContent = message
      statusEl.classList.toggle('is-error', Boolean(isError))
    }

    const applyDisabledState = () => {
      NOTIFICATION_SETTING_DEFINITIONS.forEach((definition) => {
        const input = inputsByKey[definition.key]
        if (!input) return
        // Editable once loaded, even for unregistered contacts: the setting is
        // stored as a contact-level rule and applied when they join the portal.
        let isDisabled = !isLoaded
        // Child toggles depend on the master "all" toggle.
        if (!isDisabled && definition.key !== 'all') {
          isDisabled = currentSettings.all === false
        }
        input.disabled = isDisabled
        input.parentElement?.classList.toggle('is-disabled', isDisabled)
      })
    }

    const applySettingsToInputs = () => {
      NOTIFICATION_SETTING_DEFINITIONS.forEach((definition) => {
        const input = inputsByKey[definition.key]
        if (!input) return
        input.checked = Boolean(currentSettings[definition.key])
      })
      applyDisabledState()
    }

    const buildAuthHeader = () => {
      try {
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const token = authData?.token
        if (!token) return null
        return { Authorization: `Bearer ${token}` }
      } catch (error) {
        console.error('Error parsing auth from localStorage:', error)
        return null
      }
    }

    NOTIFICATION_SETTING_DEFINITIONS.forEach((definition) => {
      const row = document.createElement('div')
      row.className = `impowerx-notifications-row${definition.isChild ? ' is-child' : ''}`

      const label = document.createElement('label')
      label.className = 'impowerx-notifications-label'
      label.textContent = definition.label
      label.setAttribute('for', `impowerx-contact-notifications-${definition.key}`)

      const switchWrapper = document.createElement('label')
      switchWrapper.className = 'impowerx-notifications-switch'

      const input = document.createElement('input')
      input.type = 'checkbox'
      input.id = `impowerx-contact-notifications-${definition.key}`
      input.dataset.notificationKey = definition.key
      input.disabled = true

      const slider = document.createElement('span')
      slider.className = 'impowerx-notifications-slider'

      switchWrapper.append(input, slider)
      row.append(label, switchWrapper)
      body.append(row)
      inputsByKey[definition.key] = input

      input.addEventListener('change', () => {
        if (!isLoaded) {
          input.checked = Boolean(currentSettings[definition.key])
          return
        }

        const nextSettings = { ...currentSettings }
        const nextValue = input.checked
        if (definition.key === 'all') {
          nextSettings.all = nextValue
          // Disabling the master toggle implicitly switches every child off so
          // the buffered payload matches what the user sees.
          if (!nextValue) {
            nextSettings.statusChanges = false
            nextSettings.newUploadedDocuments = false
            nextSettings.phaseChanges = false
          }
        } else {
          nextSettings[definition.key] = nextValue
        }

        currentSettings = nextSettings
        isDirty = true
        applySettingsToInputs()
      })
    })

    const loadSettings = async () => {
      const authHeader = buildAuthHeader()
      if (!authHeader) {
        setStatusMessage('Nicht angemeldet. Einstellungen können nicht geladen werden.', { isError: true })
        return
      }

      try {
        const response = await fetch(
          `${baseApiUrl}/api/notification-settings/contact/${currentContactId}`,
          {
            headers: { ...authHeader, 'Content-Type': 'application/json' },
            signal: abortController.signal,
          }
        )

        if (!response.ok) {
          setStatusMessage('Einstellungen konnten nicht geladen werden.', { isError: true })
          return
        }

        const data = await response.json()
        currentSettings = {
          ...NOTIFICATIONS_DEFAULT_SETTINGS,
          ...(data?.notificationSettings || {}),
        }
        isRegistered = Boolean(data?.isRegistered)
        isLoaded = true

        if (!isRegistered) {
          setStatusMessage('Für diesen Kontakt ist noch kein Portal-Benutzer registriert. Die Einstellungen werden gespeichert und angewendet, sobald der Kontakt dem Portal beitritt.')
        } else {
          setStatusMessage('')
        }

        applySettingsToInputs()
      } catch (error) {
        if (error?.name === 'AbortError') return
        console.error('Error loading notification settings:', error)
        setStatusMessage('Einstellungen konnten nicht geladen werden.', { isError: true })
      }
    }

    const saveNotificationSettings = async () => {
      if (!isLoaded) return false
      if (saveInFlight) return saveInFlight
      if (!isDirty) return true
      if (
        getActiveContactEditId() !== currentContactId ||
        !document.body.contains(section)
      ) {
        clearNotificationsSaver(currentContactId)
        return false
      }

      const authHeader = buildAuthHeader()
      if (!authHeader) {
        setStatusMessage('Nicht angemeldet. Einstellungen konnten nicht gespeichert werden.', {
          isError: true,
        })
        return false
      }

      // Claim the save synchronously before the first await so concurrent
      // Speichern clicks (capture handler or saver) share one in-flight chain.
      saveInFlight = (async () => {
        try {
          while (isDirty) {
            // Snapshot the next payload before the POST; toggles during the
            // request set isDirty again and trigger another loop iteration.
            isDirty = false
            const payload = { ...currentSettings }

            const response = await fetch(
              `${baseApiUrl}/api/notification-settings/contact/${currentContactId}`,
              {
                method: 'POST',
                headers: { ...authHeader, 'Content-Type': 'application/json' },
                body: JSON.stringify({ notificationSettings: payload }),
                keepalive: true,
              }
            )

            if (!response.ok) {
              isDirty = true
              setStatusMessage('Speichern fehlgeschlagen.', { isError: true })
              return false
            }

            const data = await response.json()
            if (!isDirty) {
              currentSettings = {
                ...NOTIFICATIONS_DEFAULT_SETTINGS,
                ...(data?.notificationSettings || payload),
              }
              applySettingsToInputs()
            }
          }
          return true
        } catch (error) {
          isDirty = true
          console.error('Error saving notification settings on Speichern:', error)
          setStatusMessage('Speichern fehlgeschlagen.', { isError: true })
          return false
        } finally {
          saveInFlight = null
        }
      })()

      return saveInFlight
    }

    // Wire this section's saver into the page-level Speichern listener and
    // ensure the listener itself is installed (idempotent).
    contactNotificationsSaveState.contactId = currentContactId
    contactNotificationsSaveState.saver = saveNotificationSettings
    contactNotificationsSaveState.needsSave = () => isLoaded && isDirty
    contactNotificationsSaveState.getSaveInFlight = () => saveInFlight
    ensureNotificationsSpeichernListener()

    // Insert immediately after #person so the section sits with the other
    // contact-related sub-sections (e.g. tax assumption).
    personDiv.parentNode.insertBefore(section, personDiv.nextSibling)

    loadSettings()
    return true
  }

  // Try immediately in case elements are already present
  initializeContactReportingsField()
  initializeTaxNumberField()
  initEhepartnerContactField()
  initPrivacyPolicySignedField()
  initContactRolesField()
  initializeNotificationsSettingsSection()
  initializeTaxAssumption()
  initMultiContactUi()
  initKontaktierenViaDispatchPreferences({
    mode: 'edit',
    getContactId: getActiveContactEditId,
  })

  // Set up MutationObserver to watch for DOM changes
  // Keep observer running so it can re-initialize the field if elements are removed/re-added during navigation
  const observer = new MutationObserver(() => {
    initializeContactReportingsField()
    initializeTaxNumberField()
    initEhepartnerContactField()
    initPrivacyPolicySignedField()
    initContactRolesField()
    initializeNotificationsSettingsSection()
    initializeTaxAssumption()
    initMultiContactUi()
    initKontaktierenViaDispatchPreferences({
      mode: 'edit',
      getContactId: getActiveContactEditId,
    })
  })

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })
}
